// extracted by css-extract-rspack-plugin
export default {"form":"FI4EVb5paMAf5DHl"};